<template>
  <div class="brands">
    <el-image
      class="banner pc"
      fit="cover"
      :src="require('@/assets/images/tjhj/red-background.png')"
    ></el-image>
    <div class="container content card-shadow">
      <div class="filter-area">
        <div class="type-filter-1">
          <typeFilter
            name="分 类"
            wholeTypeName="全部"
            :types="types"
            :defaultType="0"
            @type-change="handleTypeChange"
          />
        </div>
        <div class="type-filter-2">
          <typeFilter
            name="院 校"
            wholeTypeName="全部"
            :types="orgs"
            :defaultType="0"
            @type-change="handleOrgChange"
          />
        </div>
      </div>
      <div class="brand-list" v-loading="loading">
        <el-row :gutter="40">
          <el-col :sm="8" v-for="(item, index) in getBrandsByPage()" :key="index">
            <div
              class="brand-item card-shadow has-hover can-click hover-bigger"
              @click="viewBrand(item)"
            >
              <div class="cover-border">
                <div class="cover-wrapper">
                  <el-image class="cover" fit="cover" :src="getCover(item.url)"></el-image>
                </div>
              </div>
              <div class="brand-right">
                <h1 class="text-ellipsis">
                  <i class="iconfont iconpinpaizhanshi-kecheng pc"></i>
                  {{ item.name }}
                </h1>
                <div class="brand-info name text-ellipsis">主讲老师：{{ item.teachers }}</div>
                <div class="brand-info school name pc text-ellipsis">{{ item.school }}</div>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          layout="prev, pager, next, jumper"
          :total="total"
          :hide-on-single-page="true"
        ></el-pagination>

        <div class="empty-tip" v-if="getBrandsByPage().length === 0">-暂无数据-</div>
      </div>
    </div>
  </div>
</template>

<script>
import typeFilter from "../components/typeFilter.vue";
import { unionOrgs } from "@/api/mock.js";
import { brands } from "@/api/api.js";
import util from "@/libs/util.js";

export default {
  name: "brands",
  props: {
    orgId: {
      type: String,
      default: "0"
    }
  },
  data() {
    return {
      site: "",
      orgs: [],
      types: [],
      currentOrg: 0,
      currentType: 0,
      currentPage: 1,
      pageSize: 12,
      total: 0,
      brands: [],
      allBrands: [],
      loading: false
    };
  },
  created() {
    this.site = this.$route.meta;
   console.log(this.$route);
    unionOrgs({ id: 12 })
      .then(res => {
        // 返回数据
        for (let i = 0; i < res.list.length; i++) {
          let item = res.list[i];
          item.id = item.orgid;
          item.name = item.orgname;
        }
        this.orgs = res.list;

        this.getBrands();
      })
      .catch(err => {
        // 异常情况
        console.log(err);
      });
  },
  methods: {
    getBrands() {
      this.loading = true;
      brands()
        .then(res => {
          // 处理数据
          let typeDatas = res.wholepageChapterDTOList;
          for (let i = 0; i < typeDatas.length; i++) {
            let type = typeDatas[i];
            this.types.push({
              id: type.chapterid,
              name: type.title
            });

            let orgDatas = type.wholepageItemDTOList;
            for (let j = 0; j < orgDatas.length; j++) {
              let orgData = orgDatas[j];
              let org = this.getOrgByName(orgData.title);
              if (!org) {
                continue;
              }

              for (let k = 0; k < orgData.wholepageDTOList.length; k++) {
                let brand = orgData.wholepageDTOList[k];
                let video = brand.coursepageDTOList[0];

                if (!video) {
                  continue;
                }

                let b = {
                  id: video.resourceid,
                  name: brand.content,
                  cover: video.avatorFullurl,
                  url: video.resourceFullurl,
                  teachers: util.replaceTag(video.note),
                  school: orgData.title,
                  type: type.chapterid,
                  org: org.id
                };
                this.allBrands.push(b);
              }
            }
          }

          this.brands = this.allBrands;
          this.total = this.brands.length;

          this.handleOrgChange(parseInt(this.orgId));

          this.loading = false;
        })
        .catch(err => {
          // 异常情况
          console.log(err);
          this.loading = false;
        });
    },
    getBrandsByPage() {
      // 模拟分页
      return this.brands.slice(
        (this.currentPage - 1) * this.pageSize,
        this.currentPage * this.pageSize
      );
    },
    getOrgByName(name) {
      let result = null;
      for (let i = 0; i < this.orgs.length; i++) {
        let org = this.orgs[i];

        if (org.name === name) {
          result = org;
        }
      }

      return result;
    },
    getOrgById(id) {
      let result = null;
      for (let i = 0; i < this.orgs.length; i++) {
        let org = this.orgs[i];

        if (org.id === id) {
          result = org;
        }
      }

      return result;
    },
    handleTypeChange(val) {
      // 模拟筛选
      this.currentPage = 1;
      this.currentType = val;

      this.filterBrands();
    },
    handleOrgChange(val) {
      // 模拟筛选
      this.currentPage = 1;
      this.currentOrg = val;

      this.filterBrands();
    },
    filterBrands() {
      if (this.currentType === 0 && this.currentOrg === 0) {
        this.brands = this.allBrands;
      } else {
        let brands = [];

        for (let i = 0; i < this.allBrands.length; i++) {
          let brand = this.allBrands[i];

          if (
            (brand.type === this.currentType || this.currentType === 0) &&
            (brand.org === this.currentOrg || this.currentOrg === 0)
          ) {
            brands.push(brand);
          }
        }

        this.brands = brands;
      }

      this.total = this.brands.length;
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    getCover(url) {
      return url + "?vframe/jpg/offset/10";
    },
    viewBrand(item) {
      window.open(`#/tjhj/brandContent/${item.id}`);
    }
  },
  components: {
    typeFilter
  }
};
</script>

<style scoped>
.banner {
  display: block;
  height: 140px;
}

.tjxd .banner {
  display: none;
}
.hnwgy .banner {
  display: none;
}

.content {
  position: relative;
  z-index: 2;
  margin-top: -90px;
  margin-bottom: 80px;
  padding: 30px;
  background-color: #fff;
  border: 1px solid #eaeaea;
}

.tjxd .content {
  margin-top: 0;
  padding: 30px 0;
  background-color: unset;
  border: unset;
  box-shadow: unset !important;
}
.hnwgy .content {
  margin-top: 0;
  padding: 30px 0;
  background-color: unset;
  border: unset;
  box-shadow: unset !important;
}

.tjxd .type-filter-2 {
  display: none;
}
.hnwgy .type-filter-2 {
  display: none;
}

.brand-list {
  margin-top: 28px;
}

.brand-item {
  margin-bottom: 40px;
  padding: 16px;
  background-color: #d9ae73;
  cursor: pointer;
}

.tjxd .card-shadow.has-hover:hover {
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.3) !important;
}

.brand-item .cover-border {
  border: 4px solid #ffe8ad;
}

.brand-item .cover-wrapper {
  position: relative;
  padding-bottom: 56.25%;
}

.cover-wrapper .cover {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #eee;
}

.brand-item h1 {
  margin-top: 14px;
  height: 24px;
  line-height: 24px;
  font-size: 18px;
  color: #b92e32;
}

.tjxd .brand-item h1 {
  color: #9b3a0d;
}

h1 .iconfont {
  margin-right: 6px;
  font-size: 18px;
}

.brand-item .brand-info {
  margin-top: 10px;
  height: 16px;
  line-height: 16px;
  font-size: 14px;
  font-weight: bold;
}

.can-click:hover .name {
  color: #b92e32;
}

.tjxd .can-click:hover .name {
  color: #9b3a0d;
}

.tjxd .brand-item .school {
  display: none;
}

@media (max-width: 767px) {
  .content {
    margin-top: 0;
    margin-bottom: 30px;
    padding: 10px 15px 0;
    border: unset;
  }

  .tjxd .content {
    margin-top: 10px;
    padding: 10px 15px 0;
  }
  .hnwgy .content {
    margin-top: 10px;
    padding: 10px 15px 0;
  }

  .type-filter-2 {
    margin-top: 10px;
  }

  .brand-list {
    margin-top: 15px;
    padding: 0;
  }

  .brand-item {
    margin-bottom: 15px;
    padding: 10px;
  }

  .brand-item .cover-border {
    float: left;
    margin-right: 10px;
    width: 160px;
    height: 90px;
    border-width: 2px;
  }

  .brand-item .cover-wrapper {
    height: 100%;
    padding-bottom: 0;
  }

  .brand-item .brand-right {
    position: relative;
    min-height: 94px;
  }

  .brand-item h1 {
    margin-top: 0;
    height: 40px;
    line-height: 20px;
    font-size: 14px;
  }

  .brand-item .brand-info {
    position: absolute;
    left: 174px;
    bottom: 0;
    height: unset;
    line-height: 16px;
    font-size: 12px;
  }
}
</style>
